import { AggregateScoreType } from "~/operations";
import { AdjustedAggregateScoreType } from "..";

export const pageNameByType = (type: AdjustedAggregateScoreType) => {
  switch (type) {
    case AggregateScoreType.Asset:
      return "Exposed Assets";
    case AggregateScoreType.Vulnerability:
      return "Vulnerabilities";
    case AggregateScoreType.Advisory:
      return "Advisories";
    case AggregateScoreType.Check:
      return "Security checks";
    case AggregateScoreType.Software:
      return "Software";
    case "AllSecurityFindings":
      return "All Security Findings";
    default:
      return "";
  }
};
